import ApiClient from 'dashboard/api/ApiClient';

// Plural account-scoped resource: the base ApiClient defaults already map to the backend
// routes — get() -> GET /card_task_types (index, returns the account's catalog of task types)
// and update(id, data) -> PATCH /card_task_types/:id, which is also how the two weekly
// working-hour schedules of a type are saved.
class CardTaskTypesAPI extends ApiClient {
  constructor() {
    super('card_task_types', { accountScoped: true });
  }
}

export default new CardTaskTypesAPI();
